export function loadTodos(token) {
    return fetch('/api/todos?token=' + token, { credentials: 'include' })
    .then((response) => {
        if (!response.ok) {
            return new Promise().reject();
        }

        return response.json();
    })
};

export function postTodo(token, title, deadline) {
    return fetch('/api/todos?token=' + token, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ title: title, deadline: deadline }),
    }).then((response) => response.json());
};

export function deleteTodo(token, id) {
    return fetch('/api/todos/' + id + '?token=' + token, {
        method: 'DELETE',
    });
}

export function putTodo(token, id, data) {
    return fetch('/api/todos/' + id + '?token=' + token, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
    });
}
